import _Object$keys from '@babel/runtime-corejs3/core-js/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js/object/get-own-property-descriptor';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js/object/get-own-property-descriptors';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js/instance/map';
import { api } from '@bilibili-maoer/web-utils';
import qs from 'qs';
import { getFetch, postFetchWithErrorToast } from '../../../utils/fetcher.js';
import '@babel/runtime-corejs3/core-js/instance/concat';

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }
function addComment(_ref) {
  var comment = _ref.comment,
      type = _ref.type,
      eId = _ref.eId;
  var COMMENT_API_URL = "".concat(api.MISSEVAN_API_PREFIX_URL, "/site/addcomment");
  return postFetchWithErrorToast({
    url: COMMENT_API_URL,
    body: qs.stringify({
      comment: comment,
      type: type,
      e_id: eId
    })
  });
}
function replyToComment(commentData) {
  var REPLY_TO_COMMENT_API_URL = "".concat(api.MISSEVAN_API_PREFIX_URL, "/site/addsubcomment");
  return postFetchWithErrorToast({
    url: REPLY_TO_COMMENT_API_URL,
    body: qs.stringify(commentData)
  });
}
var ELikeActions;

(function (ELikeActions) {
  ELikeActions[ELikeActions["Cancel"] = 0] = "Cancel";
  ELikeActions[ELikeActions["Like"] = 1] = "Like";
})(ELikeActions || (ELikeActions = {}));

function likeComment(commentId, action, isSubComment) {
  var payload = {
    comment_id: commentId,
    action: action,
    sub: isSubComment ? 1 : 0
  };
  return postFetchWithErrorToast({
    url: "".concat(api.MISSEVAN_API_PREFIX_URL, "/site/likecomment"),
    body: qs.stringify(payload) // NOTE: info 应该不会为空

  }).then(function (res) {
    var _res$info$status, _res$info;

    return (_res$info$status = res === null || res === void 0 ? void 0 : (_res$info = res.info) === null || _res$info === void 0 ? void 0 : _res$info.status) !== null && _res$info$status !== void 0 ? _res$info$status : true;
  });
}
var EDislikeActions;

(function (EDislikeActions) {
  EDislikeActions[EDislikeActions["Cancel"] = 0] = "Cancel";
  EDislikeActions[EDislikeActions["Dislike"] = 1] = "Dislike";
})(EDislikeActions || (EDislikeActions = {}));

function dislikeComment(commentId, action, isSubComment) {
  var payload = {
    comment_id: commentId,
    action: action,
    sub: isSubComment ? 1 : 0
  };
  return postFetchWithErrorToast({
    url: "".concat(api.MISSEVAN_API_PREFIX_URL, "/site/dislikecomment"),
    body: qs.stringify(payload) // NOTE: info 应该不会为空

  }).then(function (res) {
    var _res$info$status2, _res$info2;

    return (_res$info$status2 = res === null || res === void 0 ? void 0 : (_res$info2 = res.info) === null || _res$info2 === void 0 ? void 0 : _res$info2.status) !== null && _res$info$status2 !== void 0 ? _res$info$status2 : true;
  });
}
function deleteComment(commentId, isSubComment) {
  return postFetchWithErrorToast({
    url: "".concat(api.MISSEVAN_API_PREFIX_URL, "/person/deleteComment"),
    body: qs.stringify({
      id: commentId,
      sub: isSubComment ? 1 : 0
    })
  }).then(function (res) {
    return res && res.success;
  });
}
function getSubComments(cId, page, pageSize) {
  return getFetch({
    url: "".concat(api.MISSEVAN_API_PREFIX_URL, "/site/getsubcomment"),
    params: {
      c_id: cId,
      pagesize: pageSize,
      p: page
    }
  }).then(function (resp) {
    // NOTE: info 应该不会为空
    if (!(resp !== null && resp !== void 0 && resp.info)) {
      return {
        subComments: [],
        pagination: {
          maxpage: 0,
          p: page,
          pagesize: pageSize,
          count: 0,
          hasMore: false
        }
      };
    }

    var _resp$info$subcomment = resp.info.subcomment,
        subComments = _resp$info$subcomment.Datas,
        pagination = _resp$info$subcomment.pagination;
    return {
      subComments: subComments,
      pagination: pagination,
      emotes: resp.info.emotes
    };
  });
}

function wrapRawComment(data) {
  return _objectSpread(_objectSpread({}, data), {}, {
    commentType: 'comment',
    subcomments: data.subcomments
  });
}

function getComments(eId, type, pageSize, page, sortOrder) {
  var payload = {
    type: type,
    e_id: eId,
    order: sortOrder,
    p: page,
    pagesize: pageSize
  };
  return getFetch({
    url: "".concat(api.MISSEVAN_API_PREFIX_URL, "/site/getcomment"),
    params: payload
  }).then(function (resp) {
    var _context;

    if (!resp.info) {
      return {
        comments: [],
        totalComments: 0,
        pagination: {
          maxpage: 0,
          p: page,
          pagesize: pageSize,
          count: 0,
          hasMore: false
        }
      };
    }

    var res = resp.info.comment;
    return {
      comments: _mapInstanceProperty(_context = res.Datas).call(_context, function (comment) {
        return wrapRawComment(comment);
      }),
      pagination: res.pagination,
      totalComments: res.num,
      emotes: resp.info.emotes
    };
  });
}
var DEFAULT_NUM_RECOMMENDATION = 3;
function getRecommendations(eId, type) {
  var numRecommendations = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_NUM_RECOMMENDATION;
  var SORT_BY_RECOMMENDATION = 3;
  return getComments(eId, type, numRecommendations, 1, SORT_BY_RECOMMENDATION);
}
var ECommentKind;

(function (ECommentKind) {
  // enum 定义里使用外层声明过的变量应该无影响

  /* eslint-disable @typescript-eslint/no-shadow */
  ECommentKind[ECommentKind["Comment"] = 0] = "Comment";
  ECommentKind[ECommentKind["SubComment"] = 1] = "SubComment";
  /* eslint-enable @typescript-eslint/no-shadow */
})(ECommentKind || (ECommentKind = {}));

function getCommentOrSubCommentPosition(cId, type) {
  return getFetch({
    url: "".concat(api.MISSEVAN_API_PREFIX_URL, "/site/commentJump"),
    body: qs.stringify({
      c_id: cId,
      sub: type
    })
  }).then(function (resp) {
    if (!resp.info) {
      throw new Error('api error');
    }

    var _resp$info = resp.info,
        page = _resp$info.Cpage,
        rootId = _resp$info.Cid,
        subcomment = _resp$info.subcomment;
    return {
      page: page,
      cId: rootId,
      subComments: {
        comments: subcomment.Datas,
        pagination: subcomment.pagination
      }
    };
  });
}

export { ECommentKind, EDislikeActions, ELikeActions, addComment, deleteComment, dislikeComment, getCommentOrSubCommentPosition, getComments, getRecommendations, getSubComments, likeComment, replyToComment };
